import links from "@/links/links";

export default {
  actions: {
    FETCH() {
      // ???: ???????????????????????????????????????????????????? gets too many data
      return this.get(links.BUILDING_FETCH(), {
        dataKey: "hydra:member",
      });
    },
    // NOTE: get with related building_owners, building_lots
    GET(id) {
      return this.get(links.BUILDING_GET(id), {
        dataTransformer: res => {
          // ???: ????????????????????????????????????????????????????
          // HACK: don't save meetings in store
          var building = res.data;
          delete building.meetings;
          return building;
        },
      });
    },
    GET_BUILDING_MAJORITIES(buildingId) {
      return this.get(links.BUILDING_GET(buildingId) + '/get_building_majorities', {
        dataKey: "hydra:member",
      });
    },  
  },
};
